import { isAllCollapsed } from '@ardoq/common-helpers';
import type { RelationshipsNode } from './types';
import { includeAllDescendants } from './util';

export const isCollapsibleGroup = (node: RelationshipsNode): boolean =>
  !node.isSynthetic && Boolean(node.children?.length);

export type GroupOpenDecision = (nodeId: string) => boolean;

export const getGroupOpenDecision = (
  collapsedGroupIds: string[]
): GroupOpenDecision => {
  const isCollapseAll = isAllCollapsed(collapsedGroupIds);
  const collapsedSet = new Set(collapsedGroupIds);

  return nodeId => (isCollapseAll ? false : !collapsedSet.has(nodeId));
};

export const applyCollapsedGroupIds = (
  rootNode: RelationshipsNode,
  collapsedGroupIds: string[]
): void => {
  const isOpen = getGroupOpenDecision(collapsedGroupIds);

  for (const node of includeAllDescendants(rootNode)) {
    if (!isCollapsibleGroup(node)) continue;
    node.open = isOpen(node.id);
  }
};
